import { defineMessages } from 'react-intl';

export default defineMessages({
  ariaLabel: {
    id: 'neptune.CloseButton.ariaLabel',
    defaultMessage: 'Close',
    description: 'Description of close button',
  },
});
